<script setup lang="ts">
import Icon from "./Icon.vue";
import { toasts, dismiss } from "../composables/feedback";
import { t } from "../i18n";
</script>
<template>
  <div class="toast-stack" aria-live="polite">
    <TransitionGroup name="pop"
      ><div v-for="item in toasts" :key="item.id" class="toast" role="status">
        <span class="grow">{{ item.text }}</span
        ><button
          v-if="item.action"
          class="toast-action"
          @click="
            item.action();
            dismiss(item.id);
          "
        >
          {{ item.actionLabel }}
        </button>
        <button
          type="button"
          class="toast-close"
          :aria-label="t('common.close')"
          @click="dismiss(item.id)"
        >
          <Icon name="close" :size="18" />
        </button></div
    ></TransitionGroup>
  </div>
</template>
